export default __webpack_public_path__ + "static/media/a-educacao-infantil-e-sua-conexao-com-a-alfabetizacao.1a43c1a3.pdf";